import React from "react";
import "./Footer.css"; // Import the CSS file for the footer styling

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2025 neuro42 Health. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
